class Timeline {
    constructor(timelineId) {
        this.timelineId = timelineId;
        this.timelineContainer = jQuery(`#${timelineId}`);
        this.timeline = this.timelineContainer.find('> .mad-timeline');
        this.markerPosition = this.timeline.data('marker-position') || null;
        this.firstEventMarkerContainer = this.timelineContainer.find('.mad-timeline__event-marker-container').first();
        this.firstEventMarker = this.firstEventMarkerContainer.find('.mad-timeline__event-marker');
        this.firstEventContent = this.timelineContainer.find('.mad-timeline__event').first().find('.mad-timeline__event-content');
        this.mainLine = jQuery('<div class="mad-timeline__event-line mad-timeline__event-line--main"></div>');
        this.backgroundLine = jQuery('<div class="mad-timeline__event-line mad-timeline__event-line--background"></div>');

        this.activationOffset = 150; // offset to trigger active state earlier

        if (this.firstEventMarkerContainer.length) {
            this.firstEventMarkerContainer.prepend(this.backgroundLine);
            this.firstEventMarkerContainer.append(this.mainLine);
            this.init();
        }
    }

    setMaxHeight() {
        const firstEvent = this.timelineContainer.find('.mad-timeline__event').first();
        const lastEventMarker = this.timelineContainer.find('.mad-timeline__event-marker').last();
        const firstEventMarker = this.timelineContainer.find('.mad-timeline__event-marker').first();
        const firstEventHeight = firstEvent.outerHeight();
        const markerHeight = firstEventMarker.height();

        // total line span
        const totalHeight = lastEventMarker.offset().top - firstEventMarker.offset().top;
        this.backgroundLine.css('height', totalHeight + 'px');
        this.mainLine.css('max-height', totalHeight + 'px');

        // decide top offset
        let topOffset;
        if (this.markerPosition && this.markerPosition === 'top') {
            topOffset = markerHeight / 2;
        } else if (this.markerPosition && this.markerPosition === 'center') {
            if (jQuery(window).width() < 768) {
                // top
                topOffset = markerHeight / 2;
            } else {
                // center
                topOffset = firstEventHeight / 2;
            }
        } else {
            // original responsive behavior
            if (jQuery(window).width() < 768) {
                // top
                topOffset = markerHeight / 2;
            } else {
                // center
                topOffset = firstEventHeight / 2;
            }
        }

        this.backgroundLine.css('top', topOffset + 'px');
        this.mainLine.css('top', topOffset + 'px');
    }


    updateMainLineHeight() {
        const viewportCenter = jQuery(window).scrollTop() + window.innerHeight / 2 + this.activationOffset;
        const markerCenter = this.firstEventMarker.offset().top + this.firstEventMarker.height() / 2;

        const newHeight = Math.max(0, viewportCenter - markerCenter);
        this.mainLine.css('height', newHeight + 'px');
    }

    updateActiveClass() {
        // offset to trigger active state earlier
        const viewportCenter = jQuery(window).scrollTop() + window.innerHeight / 2;
        // const animationOffset = (jQuery(window).scrollTop() + window.innerHeight) * 0.01;
        const animationOffset = 0;

        let lastActiveEvent = null;

        this.timelineContainer.find('.mad-timeline__event').each((index, element) => {
            const $element = jQuery(element);
            const eventMarker = $element.find('.mad-timeline__event-marker');
            const eventContent = $element.find('.mad-timeline__event-content');
            const eventMarkerCenter = eventMarker.offset().top + eventMarker.height() / 2;

            const isActive = viewportCenter >= (eventMarkerCenter - this.activationOffset - animationOffset);

            $element.toggleClass('active', isActive);
            eventContent.toggleClass('active', isActive);
            eventMarker.toggleClass('active', isActive);

            if (isActive && !$element.hasClass('animated')) {
                $element.css('animation-delay', (index * 0.1) + 's');
                $element.addClass('animated');
            }

            if (isActive) {
                lastActiveEvent = $element;
            }
        });

        // Always keep the first event content active
        this.firstEventContent.addClass('active');
        this.firstEventMarker.addClass('active');
        this.timelineContainer.find('.mad-timeline__event').first().addClass('active animated');
    }

    init() {
        this.setMaxHeight();
        this.updateMainLineHeight();
        this.updateActiveClass();

        jQuery(window).on('scroll', () => {
            this.updateMainLineHeight();
            this.updateActiveClass();
        });

        jQuery(window).on('resize', () => {
            this.setMaxHeight();
            this.updateMainLineHeight();
            this.updateActiveClass();
        });

        setInterval(() => {
            this.setMaxHeight();
        }, 1000)
    }
}

jQuery(document).ready(function () {
    jQuery('.mad-timeline__container').each(function () {
        const timelineId = jQuery(this).attr('id');
        new Timeline(timelineId);
    });
});
